import { useState } from 'react';
import { AccountFilters } from './filters';
import { AccountsList } from './list';
import { AccountFilter } from '../../../../shared/types/modules/account';
import { ACCOUNTS_NEW } from '../../../../routes/paths';
import { LayoutModule } from '../../../layout/modules';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';

export const Accounts = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<AccountFilter>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de cuentas"
                {...(!isOnlyViewProfile(type) && { createPath: ACCOUNTS_NEW })}
            >
                <AccountFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <AccountsList filters={filters} />
        </>
    );
};
